import { collection, doc, addDoc, getDoc, getDocs, query, where, orderBy, limit, serverTimestamp } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functions } from '../config/firebase';

export async function submitRating({ tripId, bookingId, raterId, raterRole, rateeId, rateeRole, stars, review }) {
  const fn = httpsCallable(functions, 'submitRating');
  return (await fn({ tripId, bookingId, raterId, raterRole, rateeId, rateeRole, stars, review })).data;
}

export async function getRatingsForUser(userId, maxResults = 50) {
  const q = query(collection(db, 'ratings'), where('rateeId', '==', userId), where('moderationStatus', '==', 'approved'), orderBy('createdAt', 'desc'), limit(maxResults));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function getRatingForTrip(tripId, raterId) {
  const q = query(collection(db, 'ratings'), where('tripId', '==', tripId), where('raterId', '==', raterId));
  const snap = await getDocs(q);
  return snap.docs.length > 0 ? { id: snap.docs[0].id, ...snap.docs[0].data() } : null;
}

export async function checkBothRated(tripId) {
  const q = query(collection(db, 'ratings'), where('tripId', '==', tripId));
  const snap = await getDocs(q);
  return { count: snap.docs.length, bothRated: snap.docs.length >= 2 };
}

export async function reportReview(ratingId, reason) {
  const fn = httpsCallable(functions, 'reportReview');
  return (await fn({ ratingId, reason })).data;
}
